<div class="max-w-7xl">
  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
  </div>

  <ng-container *ngIf="!loading && stats">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
      
      <!-- Powiadomienia w przeglądarce -->
      <div class="bg-card rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-4">
        <div class="text-sm text-gray-500 dark:text-gray-400">Użytkownicy z powiadomieniami przeglądarkowymi</div>
        <div class="text-3xl font-bold mt-1 dark:text-white">{{ stats.webNotificationsCount }}</div>
      </div>

      <!-- Powiadomienia mobilne -->
      <div class="bg-card rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-4">
        <div class="text-sm text-gray-500 dark:text-gray-400">Użytkownicy z powiadomieniami mobilnymi</div>
        <div class="text-3xl font-bold mt-1 dark:text-white">{{ stats.mobileNotificationsCount }}</div>
      </div>

      <!-- Powiązane konta -->
      <div class="bg-card rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors" (click)="openLinkedAccountsDialog()">
        <div class="flex items-center justify-between">
            <div class="text-sm text-gray-500 dark:text-gray-400">Osoby korzystające z powiązań kont</div>
            <mat-icon class="text-gray-400 icon-size-5" svgIcon="heroicons_outline:chevron-right"></mat-icon>
        </div>
        <div class="text-3xl font-bold mt-1 dark:text-white">{{ stats.linkedAccountsGroupsCount }}</div>
        <div class="text-xs text-gray-400 mt-1">
          Unikalne grupy połączonych kont (kliknij, aby zobaczyć szczegóły)
        </div>
      </div>

    </div>
  </ng-container>
</div>
